var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountBalance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 36.4C12.5507 36.4 11.7 35.5493 11.7 34.5V25C11.7 23.9507 12.5507 23.1 13.6 23.1C14.6493 23.1 15.5 23.9507 15.5 25V34.5C15.5 35.5493 14.6493 36.4 13.6 36.4ZM25 36.4C23.9507 36.4 23.1 35.5493 23.1 34.5V25C23.1 23.9507 23.9507 23.1 25 23.1C26.0493 23.1 26.9 23.9507 26.9 25V34.5C26.9 35.5493 26.0493 36.4 25 36.4ZM7.9 44C6.85066 44 6 43.1493 6 42.1C6 41.0507 6.85066 40.2 7.9 40.2H42.1C43.1493 40.2 44 41.0507 44 42.1C44 43.1493 43.1493 44 42.1 44H7.9ZM36.4 36.4C35.3507 36.4 34.5 35.5493 34.5 34.5V25C34.5 23.9507 35.3507 23.1 36.4 23.1C37.4493 23.1 38.3 23.9507 38.3 25V34.5C38.3 35.5493 37.4493 36.4 36.4 36.4ZM8 19.3C6.89543 19.3 6 18.4046 6 17.3V16.7361C6 15.9785 6.428 15.286 7.10557 14.9472L24.1056 6.44721C24.6686 6.16569 25.3314 6.16569 25.8944 6.44721L42.8944 14.9472C43.572 15.286 44 15.9785 44 16.7361V17.3C44 18.4046 43.1046 19.3 42 19.3H8ZM14.8377 15.3104C14.7429 15.3573 14.7763 15.5 14.8821 15.5H35.1179C35.2237 15.5 35.2571 15.3573 35.1623 15.3104L25.1776 10.363C25.0657 10.3075 24.9343 10.3075 24.8224 10.363L14.8377 15.3104Z",
    fill: "#55595F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBalance);
export default __webpack_public_path__ + "static/media/account-balance.4a3b54c46f736a15cdea33720da1cbe9.svg";
export { ForwardRef as ReactComponent };